import {
  SET_ACCOUNT,
  SET_NETWORK,
  SET_ENFORCED_NETWORK,
  SET_ACCOUNT_AND_NETWORK,
  SET_PROVIDER_NAME,
  SET_ALIAS,
  SET_PRIVATEKEY,
  SET_INBOX_MESSAGES,
  ADD_INBOX_MESSAGES,
  SET_OUTBOX_MESSAGES,
  ADD_OUTBOX_MESSAGES,
  DISCONNECT,
  AccountActionTypes,
  IAccountState,
} from './types'

export const initialState = {
  account: undefined,
  network: 1,
  enforcedNetwork: undefined,
  providerName: undefined,
  identity: undefined,
  alias: undefined,
  privatekey: undefined,
  inboxMessages: [],
  outboxMessages: [],
  networkName: 'Ethereum Mainnet',
  networkOptions: [
    {
      key: '1',
      text: 'Ethereum Mainnet',
      value: 1,
    },
    {
      key: '137',
      text: 'Polygon Mainnet',
      value: 137,
    },
    {
      key: '5',
      text: 'Goerli Testnet',
      value: 5,
    },
    {
      key: '80001',
      text: 'Mumbai Testnet',
      value: 80001,
    },
  ],
}

const reducer = (
  state: IAccountState = initialState,
  action: AccountActionTypes
): IAccountState => {
  switch (action.type) {
    case SET_ACCOUNT:
      return {
        ...state,
        account: action.payload,
      }
    case SET_NETWORK:
      return {
        ...state,
        network: action.payload,
      }
    case SET_ENFORCED_NETWORK:
      return {
        ...state,
        enforcedNetwork: action.payload,
      }
    case SET_ACCOUNT_AND_NETWORK:
      return {
        ...state,
        network: action.payload.network,
        account: action.payload.account,
      }
    case SET_PROVIDER_NAME:
      return {
        ...state,
        providerName: action.payload,
      }
    case SET_ALIAS:
      return {
        ...state,
        alias: action.payload,
      }
    case SET_PRIVATEKEY:
      return {
        ...state,
        privatekey: action.payload,
      }
    case SET_INBOX_MESSAGES:
      return {
        ...state,
        inboxMessages: action.payload,
      }
    case ADD_INBOX_MESSAGES:
      return {
        ...state,
        inboxMessages: state.inboxMessages.concat([action.payload]),
      }
    case SET_OUTBOX_MESSAGES:
      return {
        ...state,
        outboxMessages: action.payload,
      }
    case ADD_OUTBOX_MESSAGES:
      return {
        ...state,
        outboxMessages: state.outboxMessages.concat([action.payload]),
      }
    case DISCONNECT:
      return {
        ...state,
        network: 1,
        account: undefined,
        alias: undefined,
        privatekey: undefined,
        inboxMessages: [],
        outboxMessages: [],
      }
    default:
      return state
  }
}

export default reducer
